/** Build parish choices from the categories attached to the loaded public places. */
export const getParishOptions = (points: any[], territoryCategory?: number, categoryIds?: number[]) => {
    const options = new Map<number, { category: any; count: number }>();
    points.forEach(point => {
        const counted = new Set<number>();
        (point.categories ?? []).forEach((line: any) => {
            const category = line.category ?? line;
            const id = Number(category.category_id);
            if (!Number.isFinite(id) || id === territoryCategory || counted.has(id)) return;
            if (categoryIds?.length && !categoryIds.includes(id)) return;
            counted.add(id);
            const option = options.get(id);
            if (option) option.count += 1;
            else options.set(id, { category, count: 1 });
        });
    });
    return [...options.values()];
};

export const filterPointsByParish = (points: any[], categoryId: number | null) => categoryId == null ? points :
    points.filter(point => (point.categories ?? []).some((line: any) => Number((line.category ?? line).category_id) === categoryId));
